import { blogs_actions } from "../actions/actionTypes";

const initialState = {
  blogs: [],
  viewedBlog: null,
  error: null,
};


export const blogsReducer = (state = initialState, action) => {
  switch (action.type) {
    case blogs_actions.CREATE_BLOGS:
      return {
        ...state,
        blogs: [...state.blogs, action.payload],
      };

    case blogs_actions.GET_BLOGS:
      return {
        ...state,
        blogs: action.payload,
      };

    case blogs_actions.UPDATE_BLOGS:
      return {
        ...state,
        blogs: state.blogs
      };

    case blogs_actions.DELETE_BLOGS:
      return {
        ...state,
        blogs: state.blogs.filter((blog) => blog.id !== action.payload),
      };
      
      //  View Blog
    case blogs_actions.VIEW_BLOGS:
      return {
        ...state,
        viewedBlog: action.payload,
      };

    case blogs_actions.ERR_BLOGS:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};
